<template>
  <div class="place-self-start grid grid-cols-3 gap-4 w-full">
    <div id="header-footer-modal-preview-family" data-backdrop="static" class="modal grid items-start pt-4 pb-4" data-test="add-family-modal">
        <div class="modal-dialog modal-lg rounded-full my-0">
            <div class="modal-content bg-theme-25 px-2">
                <div class="modal-header">
                    <h4 class="font-medium text-base mr-auto font-bold">
                        {{`${editModal ? 'แก้ไข' : 'เพิ่ม'}ครอบครัว`}}
                    </h4>
                    <button class="btn mr-1 mb-2 border-none exiterror" @click="closeModal('canceled')">
                        <XIcon class="w-5 h-5" />
                    </button>
                </div>
                <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
                    <div class="col-span-12">
                      <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                        หัวหน้าครอบครัว
                      </h3>
                    </div>
                    <div class="col-span-12" :class="{ error: v$.idCardNumber.$errors.length || sumId === false }">
                      <label for="family-head-idcard-input" class="form-label text-theme-98">เลขบัตรประจำตัวประชาชน <span class="text-theme-5">*</span></label>
                      <div class="flex flex-wrap items-center gap-3 gap-y-2 mt-1">
                        <input
                          :disabled="editModal"
                          id="family-head-idcard-input"
                          type="text"
                          class="form-control placeholder-theme-19 flex-1 min-w-[140px] max-w-full"
                          placeholder="กรุณากรอกเลขบัตรประชาชน"
                          data-test="family-head-idcard"
                          maxlength="13"
                          v-model="state.idCardNumber"
                          @input="onlyNumber" />
                        <div class="flex gap-2 flex-shrink-0 order-2 md:order-none" v-if="!editModal">
                          <button
                            type="button"
                            class="btn btn-primary font-medium"
                            data-test="submit-add-family-button"
                            @click="checkHouseholdHead">
                            ค้นหา
                          </button>
                          <button
                            v-show="showBoraButton"
                            type="button"
                            class="btn btn-primary font-medium"
                            @click="useBoraInfo">
                            ตรวจสอบข้อมูลกับทะเบียนราษฎร์
                          </button>
                        </div>
                      </div>
                      <div class="mt-1.5">
                        <div v-if="sumId === false" class="error-msg">
                          กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง
                        </div>
                        <div v-else-if="getDataFromApi === false" class="error-msg whitespace-pre-line">
                          ไม่สามารถเพิ่มหัวหน้าครอบครัวด้วยเลขบัตรประชาชนนี้ได้ เนื่องจากพบข้อมูลของบุคคลนี้ที่
                          {{duplicateDataChecked.village_name ? `หมู่บ้าน${duplicateDataChecked.village_name}` : ''}}
                          {{duplicateDataChecked.tumbol_name ? `ตำบล${duplicateDataChecked.tumbol_name}` : ''}}
                          {{duplicateDataChecked.amphur_name ? `อำเภอ${duplicateDataChecked.amphur_name}` : ''}}
                          {{duplicateDataChecked.province_name ? `จังหวัด${duplicateDataChecked.province_name}` : ''}}
                          {{`\nผู้รับผิดชอบ: `}}{{duplicateDataChecked.case_manager?.uid ? `${duplicateDataChecked.case_manager.uid} (${duplicateDataChecked.case_manager.title} ${duplicateDataChecked.case_manager.name} ${duplicateDataChecked.case_manager.surname})` : '-'}}
                        </div>
                        <div v-else class="input-errors" v-for="error of v$.idCardNumber.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="xs:col-span-12 md:col-span-3" v-if="showHouseheadLayout">
                        <label for="dropdown-title" class="form-label text-theme-98">คำนำหน้าชื่อ <span class="text-theme-5">*</span></label>
                          <v-select
                            class="selecthh"
                            data-test="dropdown-title"
                            id="dropdown-title"
                            label="label"
                            placeholder="กรุณาเลือกคำนำหน้า"
                            :options="titles"
                            :clearable="false"
                            :disabled="getDataFromApi || editModal"
                            :class="{ errorselect: v$.titleSelected.$errors.length }"
                            v-model="state.titleSelected"
                          >
                            <template #open-indicator="{ attributes }">
                              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                          </v-select>
                        <div class="input-errors" v-for="error of v$.titleSelected.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="xs:col-span-12 md:col-span-9 pl-0 " :class="{ error: v$.firstName.$errors.length }" v-if="showHouseheadLayout">
                        <label for="family-head-firstName-input" class="form-label text-theme-98">ชื่อ <span class="text-theme-5">*</span></label>
                        <input 
                          id="family-head-firstName-input" 
                          type="text" class="form-control placeholder-theme-19"
                          placeholder="กรุณากรอกชื่อ" 
                          data-test="family-head-firstname-input" 
                          v-model="state.firstName" 
                          :disabled="getDataFromApi || editModal"/>
                        <div class="input-errors" v-for="error of v$.firstName.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                        <!-- <div v-if="v$.firstName.$error" class="error-msg">This field is required.</div> -->
                    </div>
                    <div class="xs:col-span-12 md:col-span-12" :class="{ error: v$.lastName.$errors.length }" v-if="showHouseheadLayout">
                        <label for="family-head-surname-input" class="form-label text-theme-98">นามสกุล <span class="text-theme-5">*</span></label>
                        <input 
                          id="family-head-surname-input" 
                          type="text" 
                          class="form-control placeholder-theme-19"
                          placeholder="กรุณากรอกนามสกุล" 
                          data-test="family-head-lastname-input"
                          v-model="state.lastName"
                          :disabled="getDataFromApi || editModal"/>
                        <div class="input-errors" v-for="error of v$.lastName.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="xs:col-span-12 md:col-span-12" :class="{ error: v$.birthdate.$errors.length }" v-if="showHouseheadLayout">
                        <label for="birthdate-input" class="form-label text-theme-98">วัน/เดือน/ปีเกิด <span class="text-theme-5">*</span></label>
                        <Datepicker
                            preventMinMaxNavigation
                            selectText="ตกลง"
                            cancelText="ยกเลิก"
                            locale="th"
                            data-test="birth-date"
                            :month-year-component="monthYear"
                            :format="format"
                            :previewFormat="format"
                            :maxDate="new Date()"
                            :enableTimePicker="false"
                            :monthChangeOnScroll="false"
                            :disabled="getDataFromApi || editModal"
                            v-model="state.birthdate"
                            :yearRange="[1900, new Date().getFullYear()]"
                        ></Datepicker>
                        <div class="input-errors" v-for="error of v$.birthdate.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="col-span-12 p-4 rounded-lg border border-theme-34 bg-theme-25 text-sm" v-if="showHouseheadLayout && boraInfoDisplay">
                      <div class="font-medium text-theme-20 mb-2">ข้อมูลจากทะเบียนราษฎร์</div>
                      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
                        <div><span class="text-theme-98 opacity-80">เพศ:</span> {{ state.gender || '-' }}</div>
                        <div><span class="text-theme-98 opacity-80">สัญชาติ:</span> {{ state.nationality || '-' }}</div>
                        <!-- <div><span class="text-theme-98 opacity-80">สถานะบุคคล:</span> {{ state.personstatus || '-' }}</div> -->
                        <div></div>
                        <div><span class="text-theme-98 opacity-80">เลขบัตรบิดา:</span> {{ state.fatherpid || '-' }}</div>
                        <div><span class="text-theme-98 opacity-80">ชื่อบิดา:</span> {{ state.fathername || '-' }}</div>
                        <div><span class="text-theme-98 opacity-80">สัญชาติบิดา:</span> {{ state.fathernationality || '-' }}</div>
                        <div></div>
                        <div><span class="text-theme-98 opacity-80">เลขบัตรมารดา:</span> {{ state.motherpid || '-' }}</div>
                        <div><span class="text-theme-98 opacity-80">ชื่อมารดา:</span> {{ state.mothername || '-' }}</div>
                        <div><span class="text-theme-98 opacity-80">สัญชาติมารดา:</span> {{ state.mothernationality || '-' }}</div>
                      </div>
                    </div>
                    <div class="col-span-12 sm:col-span-12 py-2" v-if="showHouseheadLayout">
                        <div class="w-full border-t dark:border-dark-5 border-theme-34"></div>
                    </div>
                    <div class="col-span-12 sm:col-span-12" v-if="showHouseheadLayout">
                      <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                        ลักษณะครอบครัว
                      </h3>
                    </div>
                    <div class="col-span-12" v-if="showHouseheadLayout">
                        <label for="family-type-selected" class="form-label text-theme-98">ลักษณะครอบครัว <span class="text-theme-5">*</span></label>
                          <v-select
                            class="selecthh"
                            data-test="family-type-selected"
                            id="family-type-selected"
                            placeholder="กรุณาเลือกลักษณะครอบครัว"
                            label="label"
                            :clearable="false"
                            :options="familyType"
                            :class="{ errorselect: v$.typeofFamilySelected.$errors.length }"
                            v-model="state.typeofFamilySelected"
                          >
                            <template #open-indicator="{ attributes }">
                              <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                          </v-select>
                        <div class="input-errors" v-for="error of v$.typeofFamilySelected.$errors" :key="error.$uid">
                          <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-right" v-if="showHouseheadLayout">
                    <button type="button" 
                      data-test="cancel-add-family-button"
                      class="btn btn-outline-secondary mr-1" 
                      @click="closeModal('canceled')">
                        ยกเลิก
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-primary w-15 font-medium" 
                      data-test="submit-add-family-button"
                      @click="submitAddFamilyForm">
                        บันทึก
                    </button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script setup>
import Swal from 'sweetalert2';
import useVuelidate from '@vuelidate/core'
import axios from 'axios'
import { ref, reactive, watch, toRefs, defineAsyncComponent, computed} from "vue";
import { useRoute } from 'vue-router';
import moment from 'moment';
import { required, helpers, minLength, maxLength } from '@vuelidate/validators'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useBoraData } from '@/utils/useBoraData';
const { getPersonInfoFromBora } = useBoraData();
import store from "@/store";
var md5 = require("md5")
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const props = defineProps({
  addFamilyModal: { type: Boolean ,default: false },
  editModal: { type: Boolean ,default: false },
  addressData: Object 
});
const { addFamilyModal } = toRefs(props);
const emit = defineEmits(['modal-value']);

const MonthYear = defineAsyncComponent(() => import('@/components/custom-datepicker/monthComponent.vue'));
const sumId = ref(true);
const submitBtn = ref(false);
const showHouseheadLayout = ref(false);
const getDataFromApi = ref(null);
const showBoraButton = ref(false);
const boraInfoDisplay = ref(null);
const hnum = ref('');
const dataFromCheckHouseholdHead = ref([]);
const householdData = ref(null);
const editModal = ref(props.editModal);
const getMemberData = ref();
const duplicateDataChecked = ref(null)

const monthYear = computed(() => MonthYear);
const format = (date) => {
            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear() + 543;

            return `${day}/${month}/${year}`;
        }
const titles = reactive([
                {id: 'นาย', label: 'นาย', }, 
                {id: 'นาง',label: 'นาง'},
                {id: 'นางสาว',label: 'นางสาว' },
                ]);
const familyType = reactive([
                {id: 'FT1', label: 'ครอบครัวเดี่ยว (พ่อ แม่ ลูก)', }, 
                {id: 'FT2',label: 'ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)'},
                {id: 'FT3',label: 'ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว' },
                {id: 'FT4',label: 'ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)' },
                {id: 'FT5',label: 'ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง' },
                {id: 'FT6',label: 'ครอบครัวคู่รักเพศเดียวกัน' },
                {id: 'FT7',label: 'ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)' },
                {id: 'FT8',label: 'อยู่คนเดียว' },
                {id: 'FT9',label: 'ครอบครัวขยาย' },
                ]);
const state = reactive({
  firstName: '',
  lastName: '',
  idCardNumber: '',
  titleSelected : null,
  typeofFamilySelected : null,
  birthdate: null,
  // ข้อมูลจากทะเบียนราษฎร์ (BORA) สำหรับแสดงและบันทึก
  dateofbirth: '', // รูปแบบ พ.ศ. YYYYMMDD จาก BORA
  pid: '',
  gender: '',
  nationality: '',
  // personstatus: '',
  fatherpid: '',
  motherpid: '',
  fathername: '',
  mothername: '',
  fathernationality: '',
  mothernationality: ''
})
const rules = {
  firstName: { required: helpers.withMessage('กรุณากรอกชื่อ', required) },
  lastName: { required: helpers.withMessage('กรุณากรอกนามสกุล', required) },
  titleSelected: { required: helpers.withMessage('กรุณาเลือกคำนำหน้า', required) },
  typeofFamilySelected: { required: helpers.withMessage('กรุณาเลือกลักษณะครอบครัว', required) },
  birthdate: { required: helpers.withMessage('กรุณาเลือกวัน/เดือน/ปีเกิด', required) },
  idCardNumber: { 
    minLength: helpers.withMessage('กรุณากรอกเลขบัตรประชาชน 13 หลัก',minLength(13)),
    maxLength: helpers.withMessage('กรุณากรอกเลขบัตรประชาชน 13 หลัก',maxLength(13)),
    required: helpers.withMessage('กรุณากรอกเลขบัตรประชาชน 13 หลัก', required) 
   },
}
watch( () => props.addFamilyModal, ()=>{
  if (addFamilyModal.value){
    cash("#header-footer-modal-preview-family").modal("show");
    getHouseHold()
  }
})
watch( () => props.editModal , (val)=>{
  if (val){
    editModal.value = true
    showHouseheadLayout.value = true
    getMember(props.addressData.fam_head)
  }
})
watch( () => state.idCardNumber , ()=>{
  if (state.idCardNumber.length === 13){
    sumId.value = idState()
  }
})

const route = useRoute();
const v$ = useVuelidate(rules, state)
const onlyNumber = () => {
  state.idCardNumber = state.idCardNumber.replace(/[^\d]/g, "")
  if (state.idCardNumber.length !== 13) {
    sumId.value = null
    getDataFromApi.value = null
    showHouseheadLayout.value = false
    showBoraButton.value = false
    boraInfoDisplay.value = null
    clearBoraState()
  }
}

///////
// แปลง dateofbirth จากรูปแบบ พ.ศ. YYYYMMDD (เช่น 25380101) เป็น ISO date
const formatDateofbirthToDate = (dateofbirth) => {
  if (!dateofbirth || String(dateofbirth).trim() === '') return ''
  const s = String(dateofbirth).trim()
  if (s.length !== 8) return ''
  const yearBE = parseInt(s.slice(0, 4), 10)
  const month = s.slice(4, 6)
  const day = s.slice(6, 8)
  const yearCE = yearBE - 543
  const monthNum = parseInt(month, 10)
  const dayNum = parseInt(day, 10)
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) return ''
  const date = new Date(Date.UTC(yearCE, monthNum - 1, dayNum, 0, 0, 0, 0))
  if (isNaN(date.getTime())) return ''
  return date.toISOString()
}

const useBoraInfo = async () => {
  if (state.idCardNumber.length !== 13) {
    swalCustom.fire({
      text: "กรุณากรอกเลขบัตรประชาชน 13 หลักก่อนตรวจสอบกับทะเบียนราษฎร์",
      icon: "warning",
      confirmButtonText: "ปิด",
    })
    return
  }
  const idValid = idState()
  if (!idValid) {
    swalCustom.fire({
      text: "กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง",
      icon: "warning",
      confirmButtonText: "ปิด",
    })
    return
  }

  // const token = "some token";
  // const config = {
  //     url: `BORA url`,
  //     method: 'POST',
  //     headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": `application/json; charset=utf-8`,
  //     },
  //     data: {
  //         nid: state.householdHeadIdCardNo
  //     }
  // };
  // const res = await axios(config);
  // const boraInfo = res.data;
  const boraInfo = Object.freeze(await getPersonInfoFromBora(state.idCardNumber));
  if (!boraInfo) {
    return;
  }
  if (boraInfo.Code !== undefined && boraInfo.Code !== "0") {
    swalCustom.fire({
      text: "ไม่พบข้อมูลจากระบบทะเบียนราษฎร์",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return;
  }
  if (boraInfo.province !== store.getters["userAuth/getUserProvinceName"]) {
    swalCustom.fire({
      text: "ที่อยู่ตามทะเบียนราษฎร์ ไม่อยู่ในพื้นที่รับผิดชอบ",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return;
  }

  if (!editModal.value) {
    const boraTitle = titles.find((title) => title.label === boraInfo.title);
    state.titleSelected = boraTitle || null;
    state.firstName = boraInfo?.firstname || null;
    state.lastName = boraInfo?.lastname || null;
    state.dateofbirth = boraInfo?.dateofbirth || '';
    const isoBirth = formatDateofbirthToDate(boraInfo?.dateofbirth);
    state.birthdate = isoBirth ? new Date(isoBirth) : null;
    state.gender = (boraInfo?.gender === "1" || String(boraInfo?.gender).includes("ชาย")) 
    ? "ชาย" 
    : (boraInfo?.gender === "2" || String(boraInfo?.gender).includes("หญิง")) 
        ? "หญิง" 
        : (boraInfo?.gender || '');
    state.nationality = boraInfo?.nationality || '';
    // state.personstatus = boraInfo?.personstatus || '';
    state.fatherpid = boraInfo?.fatherpid || '';
    state.motherpid = boraInfo?.motherpid || '';
    state.fathername = boraInfo?.fathername || '';
    state.mothername = boraInfo?.mothername || '';
    state.fathernationality = boraInfo?.fathernationality || '';
    state.mothernationality = boraInfo?.mothernationality || '';
    boraInfoDisplay.value = true;
  }
};

const addBoraButton = () => {
  showBoraButton.value = true;
};
///////
const idState = () => {
      if (state.idCardNumber.length == 13) {
        var sum, i;
        if (state.idCardNumber.substring(0, 1) == 0) return false;
        for (i = 0, sum = 0; i < 12; i++)
          sum += parseFloat(state.idCardNumber.charAt(i)) * (13 - i);
        if ((11 - (sum % 11)) % 10 != parseFloat(state.idCardNumber.charAt(12)))
          return false;
        return true;
      } else if (state.idCardNumber.length > 1) {
        return false;
      } else {
        return null;
      }
};
const getHouseHold = async() => {
  try {
    await axios.post(`${process.env.VUE_APP_BASE_API}household/getHouseSurveyById`,{
      houseId:props.addressData._id
    }).then ((res) => {
      if(res.status === 200){
        householdData.value = res.data
        }
        else{
          Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
          })
        }   
    })
  } catch (error) {
    console.log(error.message);
  }
};
const getMember = (fam_head) =>{
  try {
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`,{
      member_nid : fam_head
    })
    .then((res) => {
      if(res.status === 200){
        getMemberData.value = res.data
        state.idCardNumber = getMemberData.value.national_id
        state.firstName = getMemberData.value.name
        state.lastName = getMemberData.value.surname
        state.titleSelected = getMemberData.value.title
        state.typeofFamilySelected = {id:props.addressData.fam_type.code , label:props.addressData.fam_type.desc}
        state.birthdate = getMemberData.value.birthdate
        }
        else{
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }   
    })
  } catch (error) {
    console.log(error.message);
    
  }
};
const checkHouseholdHead = async() => {
  state.firstName = null  
  state.lastName = null
  state.birthdate = null
  state.titleSelected = null;
  state.typeofFamilySelected = null;
  state.birthdate = null;
  showBoraButton.value = false;
  boraInfoDisplay.value = null;
  clearBoraState();
  var isFormCorrect = await v$.value.idCardNumber.$validate()
  sumId.value = await idState()
  if (sumId.value && isFormCorrect){
    try { 
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberSurveyById`,{
      member_nid : state.idCardNumber
    })
    .then((res) => {
      dataFromCheckHouseholdHead.value = res
        if (res.status === 200){
          let isDuplicateMember = true
          if (typeof res.data.national_id != 'undefined'){
            if(res.data.national_id == state.idCardNumber) {//duplicate check nationid
              isDuplicateMember = true
            }
            else{
              isDuplicateMember = false
            }
          }
          else{
            isDuplicateMember = false
          }

          if(isDuplicateMember){
            if (route.params.hhid === res.data.hh_id) {
              getDataFromApi.value = true
              showHouseheadLayout.value = true
              hnum.value = res.data.hnum
              state.firstName = res.data.name
              state.lastName = res.data.surname
              state.titleSelected = res.data.title
              state.birthdate = res.data.birthdate
            }
            else{
              showHouseheadLayout.value = false
              getDataFromApi.value = false
              state.firstName = null
              state.lastName = null
              state.titleSelected = null
              state.birthdate = null
              duplicateDataChecked.value = res.data
            }
          }
          else{
            getDataFromApi.value = null
            showHouseheadLayout.value = true
            state.firstName = null
            state.lastName = null
            state.titleSelected = null
            state.birthdate = null
            duplicateDataChecked.value = null
            addBoraButton();
            // useBoraInfo()
          }
        }
        else {
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }
      })
    } catch (error) {
      console.log(error.message);
    }
  }
};
const updateFamily = async() => {
  try {
    await axios.put(`${process.env.VUE_APP_BASE_API}family/${getMemberData.value.fam_id} `,{
      update: {
        fam_type: {
            code: state.typeofFamilySelected.id,
            desc: state.typeofFamilySelected.label
        },
        status : "modified",
        modified_by: store.getters["userInfo/getUserInfoForApi"]
      }
     }).then((response) => {
       if(response.status === 200){
          swalCustom.fire({
            text:"สำเร็จ",
            icon: 'success',
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(()=>{
            closeModal("saved")
          })
        }
        else{
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }   

     })
  } catch (error) {
    console.log(error.message);
  }
};
const updateMember = async(insert_id) => {
  try {
     await axios.put(`${process.env.VUE_APP_BASE_API}member/${dataFromCheckHouseholdHead.value.data._id} `,{ //id from get member
       update: {
          fam_id: insert_id,
          is_fam_head: 1,
          status : "modified",
          modified_by: store.getters["userInfo/getUserInfoForApi"],
        }
     }).then((response) => {
       if(response.status === 200){
          swalCustom.fire({
            text:"สำเร็จ",
            icon: 'success',
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(()=>{
            closeModal("saved")
          })
        }
        else{
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }   

     })
  } catch (error) {
    console.log(error.message);
  }
};
const submitAddFamilyForm  = async () => {
    submitBtn.value = true
    const isFormCorrect = await v$.value.$validate()
    sumId.value = await idState()
    if (isFormCorrect && sumId.value) {
      swalCustom.fire({
        text:"ยืนยันบันทึกข้อมูล",
        icon:"info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          if(editModal.value){
            updateFamily()
          }
          else{
            sentApiFamily() 
          }
        }
      })
    } 
};
const sentApiFamily = async () => {
  try {
    await axios.post(`${process.env.VUE_APP_BASE_API}family/`,{
    doc: {
        hh_id: route.params.hhid,
        fam_head: state.idCardNumber,
        fam_type: {
            code: state.typeofFamilySelected.id,
            desc: state.typeofFamilySelected.label
        },
        have_num: props.addressData.have_num,
        hnum: props.addressData.hnum,
        hh_code: props.addressData.hh_code,
        moo: props.addressData.moo,
        soi: props.addressData.soi,
        road: props.addressData.road,
        province_code: props.addressData.province_code,
        province_name: props.addressData.province_name,
        postcode: props.addressData.postcode,
        village_code: props.addressData.village_code,
        village_name: props.addressData.village_name,
        tumbol_code: props.addressData.tumbol_code,
        tumbol_name: props.addressData.tumbol_name,
        amphur_code: props.addressData.amphur_code,
        amphur_name: props.addressData.amphur_name,
        mso_osm: props.addressData.mso_osm ? props.addressData.mso_osm : null,
        volunteer: householdData.value.volunteer,
        case_manager: householdData.value.case_manager,
        status : "created",
        created_by: store.getters["userAuth/getUsername"]
    }
    }).then((response) => {
      if(response.status === 200){
        if (getDataFromApi.value === true){
          updateMember(response.data.insertedId)
        }
        else{
          sentApiMember(response.data.insertedId)
        }
      } 
      else{
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        })
      }   
      })
  } catch (error) {
    console.log(error.message);
    swalCustom.fire({
      text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
      icon: "warning",
      //timer: 3000, //timeOut for auto-close
      confirmButtonText: "ปิด",
      })
  }
};
const sentApiMember = async(insert_id)  => {
  state.birthdate = new Date(state.birthdate)
  state.birthdate.setUTCHours(0,0,0,0)
  try {
    const splitFullName = (full) => {
      if (!full || String(full).trim() === '') return { name: '', surname: '' }
      const parts = String(full).trim().split(/\s+/)
      if (parts.length === 1) return { name: parts[0], surname: '' }
      const surname = parts.pop()
      const name = parts.join(' ')
      return { name, surname }
    }
    const fatherSplit = splitFullName(state.fathername)
    const motherSplit = splitFullName(state.mothername)
    const boraData = {
      sex: (state.gender === "1" || String(state.gender).includes("ชาย")) 
    ? "ชาย" 
    : (state.gender === "2" || String(state.gender).includes("หญิง")) 
        ? "หญิง" 
        : (state.gender || ''),
      nationality: state.nationality || '',
      // vital_status: state.personstatus === "ปกติ" ? 1 : 0,
      father: {
        title:"นาย",
        national_id: state.fatherpid || '',
        name: fatherSplit.name,
        surname: fatherSplit.surname,
        nationality: state.fathernationality || ''
      },
      mother: {
        title:"นาง",
        national_id: state.motherpid || '',
        name: motherSplit.name,
        surname: motherSplit.surname,
        nationality: state.mothernationality || ''
      }
    }
    let _d = {
        fam_id: insert_id,
        hh_id: route.params.hhid, //url
        title: state.titleSelected.label,
        name: state.firstName,
        surname: state.lastName,
        national_id: state.idCardNumber,
        birthdate: state.birthdate,
        volunteer: householdData.value.volunteer,
        case_manager: householdData.value.case_manager,
        have_num: props.addressData.have_num,
        hnum: props.addressData.hnum,
        hh_code: props.addressData.hh_code,
        moo: props.addressData.moo,
        soi: props.addressData.soi,
        road: props.addressData.road,
        province_code: props.addressData.province_code,
        province_name: props.addressData.province_name,
        postcode: props.addressData.postcode,
        village_code: props.addressData.village_code,
        village_name: props.addressData.village_name,
        tumbol_code: props.addressData.tumbol_code,
        tumbol_name: props.addressData.tumbol_name,
        amphur_code: props.addressData.amphur_code,
        amphur_name: props.addressData.amphur_name,
        mso_osm: props.addressData.mso_osm ? props.addressData.mso_osm : null,
        is_fam_head : 1,
        status : "created",
        created_by: store.getters["userAuth/getUsername"],
        msoid: state.idCardNumber ? md5(route.params.hhid+state.idCardNumber) : md5(route.params.hhid+state.firstName+state.lastName),
      }
      if (boraInfoDisplay.value) {
      _d = { ..._d, ...boraData }
    }
    await axios.post(`${process.env.VUE_APP_BASE_API}member/`,{
      doc: _d
    }).then ((res) => {
        if(res.status === 200){
          swalCustom.fire({
            text:"สำเร็จ",
            icon: 'success',
            timer: 3000,
            confirmButtonText: "ปิด",
          }).then(()=>{
            closeModal("saved")
          })
        }
        else{
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          })
        }   
      }) 
  } catch (error) {
    console.log(error.message);
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        }) 
  }
};
const clearBoraState = () => {
  state.dateofbirth = '';
  state.pid = '';
  state.gender = '';
  state.nationality = '';
  // state.personstatus = '';
  state.fatherpid = '';
  state.motherpid = '';
  state.fathername = '';
  state.mothername = '';
  state.fathernationality = '';
  state.mothernationality = '';
};
const clearValue = () =>{
  state.firstName = '';
  state.lastName = '';
  state.idCardNumber = '';
  state.titleSelected = null;
  state.typeofFamilySelected = null;
  state.birthdate = null;
  clearBoraState();
  sumId.value = true;
  showHouseheadLayout.value = false;
  showBoraButton.value = false;
  boraInfoDisplay.value = null;
  editModal.value = false;
};
const closeModal = (state) => {
  if (!submitBtn.value){
    swalCustom.fire({
      html: `<div style="font-size:18px;"><b/>คุณต้องการออกจากหน้านี้ใช่หรือไม่</div>`,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed) {
          emit('modal-value', state);
          v$.value.$reset()
          clearValue()
          cash("#header-footer-modal-preview-family").modal("hide");
        }
      })
  }else{
    emit('modal-value', state);
    v$.value.$reset()
    clearValue()
    cash("#header-footer-modal-preview-family").modal("hide");
    // location.reload();
  }
};
</script>

<style>
#header-footer-modal-preview-family.modal {
  overflow-y: auto;
  align-items: flex-start;
}
.errorselect {
    border: 1px solid red !important;
    border-radius: 8px;
}
.error input {
  border: 1px solid red;
}
.error-msg {
  font-weight: normal;
  color: red;
  font-size: 12px;
}
.formselecterror {
  border: 1px solid red !important;
}
.form-select{
  height: 38px;
  font-size: 14px !important;
}
.btnerror{
  border: 2px solid red !important;
}
.exiterror{
  box-shadow: none !important;
}
#header-footer-modal-preview-family .vs--disabled .vs__search, #header-footer-modal-preview-family .vs--disabled .vs__selected, #header-footer-modal-preview-family .vs--disabled .vs__dropdown-toggle {
    background-color: rgba(247, 250, 252, var(--tw-bg-opacity)) !important
}
</style>